import { Message } from "@twilio/conversations";

export default {
    index: 0,
      body: "Ciao, sono l'assistente virtuale di DentalPro, come posso aiutarti oggi?",
      author: "DentalPro",
      dateCreated: new Date(),
} as Message